var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13284",
    "data-name": "Group 13284",
    transform: "translate(0.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2295",
    "data-name": "Rectangle 2295",
    transform: "translate(-0.235 0)",
    fill: "#fff",
    stroke: "#c9c9c9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Image_upload",
    "data-name": "Image upload",
    transform: "translate(14.765 64.394)",
    fill: "#c9c9c9",
    fontSize: 10,
    fontFamily: "Tajawal-Light, Tajawal",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Image upload")), /*#__PURE__*/React.createElement("path", {
    id: "image-regular",
    d: "M32.426,35.474a1.161,1.161,0,0,1,1.158,1.158V59.78l-.362-.47L23.379,46.57a1.741,1.741,0,0,0-2.75,0l-6.008,7.774-2.208-3.091a1.733,1.733,0,0,0-2.823.007L3.8,59.367l-.326.449V36.632a1.161,1.161,0,0,1,1.158-1.158ZM4.632,32A4.637,4.637,0,0,0,0,36.632V59.794a4.637,4.637,0,0,0,4.632,4.632H32.426a4.637,4.637,0,0,0,4.632-4.632V36.632A4.637,4.637,0,0,0,32.426,32Zm5.79,13.9a3.474,3.474,0,1,0-3.474-3.474A3.474,3.474,0,0,0,10.423,45.9Z",
    transform: "translate(23.765 -17.176)",
    fill: "#c9c9c9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUpload);
export default __webpack_public_path__ + "static/media/image-upload.9b39e63ca6bd2e51ef4eb5054c98d37d.svg";
export { ForwardRef as ReactComponent };